import React from "react";
import useChooseUserToClient from "./hooks";
import PickerList from "components/Picker/PickerList";
import UserWithAvatar from "components/Atoms/UserWithAvatar";

interface Props {
  onUserSelected: (user: server.dto.UserToClientSmall) => void

  excludedUsers?: number[]

  canChooseDeactivated?: boolean
  canChooseExternal?: boolean
}

const UserList = (props: Props) => {
  const chooseUser = useChooseUserToClient();

  const displayLifecycles = props.canChooseDeactivated;
  const displayEnvironment = props.canChooseExternal;

  const isActiveSelected = chooseUser.instruction.lifeCycles.includes("active");
  const isDeactivatedSelected = chooseUser.instruction.lifeCycles.includes("archived");

  const isInternalSelected = chooseUser.instruction.environment === "internal";
  const isExternalSelected = chooseUser.instruction.environment === "external";

  return <PickerList
    instruction={chooseUser.instruction}
    onInstructionChange={i => chooseUser.setInstruction(i)}
    queryKey="usersToClient"
    api={window.CoreApi.UserToClient.PaginatedSmall}
    onClick={(userToClient) => props.onUserSelected(userToClient)}
    excludeKeys={props.excludedUsers}
    getError={() => undefined}

    getId={u => u.user.userId}
    renderListItem={userToClient => <UserWithAvatar user={userToClient.user} avatarSize="avatar" />}

    filter1={displayEnvironment
      ? {
        leftButton: {
          type: "tertiary",
          isActive: isInternalSelected,
          label: RESX.UserType.Internal,
          onClick: () => { chooseUser.setEnvironment("internal"); }
        },
        rightButton: {
          type: "tertiary",
          isActive: isExternalSelected,
          label: RESX.UserType.External,
          onClick: () => { chooseUser.setEnvironment("external"); }
        }
      }
      : undefined}

    filter2={displayLifecycles
      ? {
        leftButton: {
          type: "primary",
          isActive: isActiveSelected,
          label: RESX.SoUser.Active,
          onClick: () => { chooseUser.setLifecycles(["active"]); }
        },
        rightButton: {
          type: "warning",
          isActive: isDeactivatedSelected,
          label: RESX.SoUser.Deactivated,
          onClick: () => { chooseUser.setLifecycles(["archived"]); }
        }
      }
      : undefined}
  />;
};

export default UserList;
